import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BranchMasterService } from '@/api/services/masterService';

interface BranchMaster {
    id: string;
    tenantId: string;
    corporateCode: string;
    corporateName: string;
    roCode: string;
    roName: string;
    branchCode: string;
    branchName: string;
    faCode: string;
    rbiLicNo: string;
    branchHeadsId: string;
    branchHead: string;
    place: string;
    street: string;
    state: string;
    city: string;
    pin: string;
    email: string;
    zone: string;
    phone: string;
    fax: string;
    mobile: string;
    website: string;
    serviceTaxNo: string;
    ciN_No: string;
    pan: string;
    gstin: string;
    isdNo: string;
    status: number;
}

interface BranchMasterState {
  BranchMasterlist: BranchMaster[];
  BranchlistByTenant: BranchMaster[];
  loading: boolean;
  error: string | undefined;
}

const initialState: BranchMasterState = {
  BranchMasterlist: [],
  BranchlistByTenant: [],
  loading: false,
  error: undefined,
};

export const fetchBranchMaster = createAsyncThunk(
  'BranchMaster/fetchBranchMaster',
  async (_, { rejectWithValue }) => {
    try {
      const response = await BranchMasterService.getall();         
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Failed to fetch branch masters');
    }
  }
);
export const fetchBranchByTenant = createAsyncThunk(
  'BranchMaster/fetchBranchByTenant',
  async (TenantId: string, { rejectWithValue }) => {
    try {
      const response = await BranchMasterService.getbyTenant(TenantId);         
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Failed to fetch branch masters');
    }
  }
);

// Create the slice
const BranchMasterSlice = createSlice({
  name: 'BranchMaster',
  initialState,
  reducers: {resetBranchMaster: () => initialState},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchBranchMaster.fulfilled, (state, action) => {
        state.BranchMasterlist = action.payload;
        state.loading = false;
      })
      .addCase(fetchBranchMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'Unknown error occurred';
      })
      .addCase(fetchBranchByTenant.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchBranchByTenant.fulfilled, (state, action) => {
        state.BranchlistByTenant = action.payload;
        state.loading = false;
      })
      .addCase(fetchBranchByTenant.rejected, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'Unknown error occurred';
      });
  },
});

// Export the reducer
export default BranchMasterSlice.reducer;
export const { resetBranchMaster } = BranchMasterSlice.actions;

